import { ENABLED_BILLING_RECONCILIATION_PROGRAMS } from './constants.js';
import { normalizeServiceMonth } from './serviceMonths.js';

export const BILLING_RECONCILIATION_SCOPE_STORAGE_KEY = 'billing-reconciliation-last-scope';

export const DEFAULT_BILLING_RECONCILIATION_SCOPE = {
  program: 'website',
  serviceMonth: '2026-04-01',
};

const ENABLED_PROGRAMS = new Set(ENABLED_BILLING_RECONCILIATION_PROGRAMS);

export const normalizeBillingReconciliationProgram = (value) => {
  const normalized = String(value || '').trim().toLowerCase();
  return ENABLED_PROGRAMS.has(normalized) ? normalized : null;
};

const localStorageSafe = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage || null;
  } catch (_error) {
    return null;
  }
};

export const readBillingReconciliationScopePreference = () => {
  const storage = localStorageSafe();
  if (!storage) return DEFAULT_BILLING_RECONCILIATION_SCOPE;
  try {
    const parsed = JSON.parse(storage.getItem(BILLING_RECONCILIATION_SCOPE_STORAGE_KEY) || '{}');
    return {
      program: normalizeBillingReconciliationProgram(parsed?.program) || DEFAULT_BILLING_RECONCILIATION_SCOPE.program,
      serviceMonth: normalizeServiceMonth(parsed?.serviceMonth) || DEFAULT_BILLING_RECONCILIATION_SCOPE.serviceMonth,
    };
  } catch (_error) {
    return DEFAULT_BILLING_RECONCILIATION_SCOPE;
  }
};

export const hasBillingReconciliationScopePreference = () => {
  const storage = localStorageSafe();
  if (!storage) return false;
  try {
    return Boolean(storage.getItem(BILLING_RECONCILIATION_SCOPE_STORAGE_KEY));
  } catch (_error) {
    return false;
  }
};

export const persistBillingReconciliationScopePreference = ({ program, serviceMonth }) => {
  const storage = localStorageSafe();
  if (!storage) return;
  const nextScope = {
    program: normalizeBillingReconciliationProgram(program) || DEFAULT_BILLING_RECONCILIATION_SCOPE.program,
    serviceMonth: normalizeServiceMonth(serviceMonth) || DEFAULT_BILLING_RECONCILIATION_SCOPE.serviceMonth,
  };
  try {
    storage.setItem(BILLING_RECONCILIATION_SCOPE_STORAGE_KEY, JSON.stringify(nextScope));
  } catch (_error) {
    // The page still updates in memory when browser storage is unavailable.
  }
};
